module.exports = __webpack_public_path__ + "img/winners-lockup.3bc37c6.jpg";